import {
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import NavigationBar from "./components/layout/NavigationBar";
import ReviewSharedData from "./pages/reviewSharedData/ReviewSharedData";
import ProductList from "./pages/productLists/ProductList";
import SharedData from "./pages/sharedData/SharedData";
import UserManagement from "./pages/userManagement/UserManagement";
import styles from "./app.module.scss";
import { RotatingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { createUserIfNew, selectLoading, selectToast } from "./app/appSlice";
import ToastMessage from "./components/toast/Toast";
import { palette } from "./styles/colorPalette/palette";
import Login from "./pages/login/Login";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "./app/appSlice";
import { setUser } from "./app/appSlice";
import msalInstance, {fetchIdToken} from "./app/msal";
import Dashboard from "./pages/dashboard/Dashboard";
import About from "./pages/about/about";

function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <AuthenticatedApp />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnauthenticatedApp />
      </UnauthenticatedTemplate>
    </>
  );
}

const UnauthenticatedApp = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const handleNavigation = () => {
      navigate("/login");
    };
    handleNavigation();
  }, []);
  return (
    <Routes>
      <Route path="/login" Component={Login}></Route>
    </Routes>
  );
};

const AuthenticatedApp = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const toast = useSelector(selectToast);
  const isLoading = useSelector(selectLoading);
  const navigate = useNavigate();
  const activeAccount = msalInstance.getActiveAccount();
  useEffect(() => {
    const initialiseApp = async () => {
      dispatch(setLoading({ isLoading: true }));
      let authentication = await fetchIdToken();
      dispatch(setLoading({ isLoading: false }));
      const name = authentication.account.name;
      const email = authentication.account.username;
      const roles = authentication.idTokenClaims.roles || ["Default Access"];
      dispatch(setUser({ name, email, roles }));
      dispatch(createUserIfNew({ name, email, roles }));
      handleNavigation();
    };
    initialiseApp();
  }, [msalInstance]);

  const handleNavigation = () => {
    const pathname = location.pathname;
    if (pathname === "/"|| pathname==="/login") {
      navigate("/dashboard");
    } else {
      navigate(location);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className={styles.loadingOverLay}>
          <div className={styles.loaderContainer}>
            <RotatingLines
              strokeColor={palette.daikinBlue}
              strokeWidth="5"
              animationDuration="1"
              width="30"
              visible={true}
            />
          </div>
        </div>
      )}
      {toast.isOpen && (
        <ToastMessage message={toast.message} onDismiss={toast.onDismiss} />
      )}
      <Routes>
        <Route path="/login" Component={Login}></Route>
        <Route 
          path="/dashboard"
          element={
            <>
              <NavigationBar />
              <Dashboard />
            </>
          }
          exact
        />
        <Route 
          path="/reviewItem"
          element={
            <>
              <NavigationBar />
              <ReviewSharedData />
            </>
          }
          exact
        />
        <Route
          path="/products"
          element={
            <>
              <NavigationBar />
              <ProductList />
            </>
          }
          exact
        />
        <Route
          path="/about"
          element={
            <>
              <NavigationBar />
              <About />
            </>
          }
          exact
        />
        <Route
          path="/user-management"
          element={
            <>
              <NavigationBar />
              <UserManagement />
            </>
          }
          exact
        />
        <Route
          path="/products/create-shared-data"
          element={
            <>
              <NavigationBar />
              <SharedData key={location.search} action={"createSD"} />
            </>
          }
        />
        <Route
          path="/products/view-shared-data"
          element={
            <>
              <NavigationBar />
              <SharedData key={location.search} action={"viewSD"} />
            </>
          }
        />
        <Route
          path="/products/update-shared-data"
          element={
            <>
              <NavigationBar />
              <SharedData key={location.search} action={"updateSD"} />
            </>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
